import { Validators } from "@angular/forms";


export class PatternValidator {
    static url(message: string = "Not a valid website address, needs to start with https"): any {
        return this.pattern('(https://)([\\da-z\\.-]+)\\.([a-z]{2,6})(.)*/?', message);
    }
    static email(message: string = "please enter a valid email in the format xxx@xxx.xxx"): any {
        // Lets just keep the phone validation simple, we may need to extend to cater for 1850 111 111 numbers
        return this.pattern(/^[\w.-]+@[a-zA-Z_-]+(\.[a-zA-Z]{2,3})?(\.[a-zA-Z]{2,3})$/, message);
    }

    static phone(message: string = "please enter a valid phone in the format +353XXXXXXXX or +44xxxxxxx."): any {

        // Lets just keep the phone validation simple, we may need to extend to cater for 1850 111 111 numbers
        return this.pattern(/^((\+353)((8[0-9][0-9]{7})|([0-9]{1,3}[0-9]{5,7})))|((\+44)[0-9]{2,4}[0-9]{4,8})$/, message);
    }

    static noWhiteSpace(message: string = "please enter a value") {
        return function (control) {
            if (control.value && control.value.length > 0) {
                const isWhitespace = (control.value || '').trim().length === 0;
                const isValid = !isWhitespace;
                return isValid ? null : { 'whitespace': { 'message': message } };
            }
            return null;
        };
    }


    static pattern(pattern: any, message: string) {


        if (!pattern)
            return Validators.nullValidator;
        var regex: RegExp;
        var regexStr: string | RegExp;

        if (typeof pattern === 'string') {
            regexStr = '';
            if (pattern.charAt(0) !== '^')
                regexStr += '^';
            regexStr += pattern;
            if (pattern.charAt(pattern.length - 1) !== '$')
                regexStr += '$';
            regex = new RegExp(regexStr);
        }
        else {
            regexStr = pattern;
            regex = pattern;
        }
        return function (control: any) {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }
            var value = control.value;
            return regex.test(value) ? null :
                { 'pattern': { 'message': message, 'requiredPattern': regexStr, 'actualValue': value } };
        };
    }


}


function isEmptyInputValue(value: any) {
    // we don't check for string here so it also works with arrays
    return value == null || value.length === 0;
}